<div class="page-container">
  <app-loader *ngIf="!course" [text]="'Kurs wird geladen' | translate"></app-loader>
  <ng-container *ngIf="course">
    <div class="header">
      <div>
        <app-breadcrumbs [breadcrumbs]="breadcrumbs"></app-breadcrumbs>
        <h1>{{course!.name}}</h1>
      </div>
    </div>

    <app-tabs-buttons [buttons]="tabButtons" [(selectedButton)]="selectedTabButton" (selectedButtonChange)="changeView($event)"></app-tabs-buttons>

    <div *ngIf="selectedTabButton.view === 'learnsets'">
      <div class="list">
        <app-button *ngIf="deviceSize === 'desktop' && course.learnsets.length > 0" [text]="'Neues Lernset'" [leftIcon]="'fa-plus'" [size]="'small'" [style]="'outlined'" (clickEvent)="addLearnset()"></app-button>
        <app-learnsets-list *ngIf="course.learnsets.length > 0" [learnsets]="course.learnsets" (learnsetClicked)="showLearnset($event)"></app-learnsets-list>
        <app-add-item-widget *ngIf="course.learnsets.length === 0" [message]="'learnset.add_learnset_message' | translate" [buttonText]="'Lernset erstellen'" (buttonClicked)="addLearnset()"></app-add-item-widget>
      </div>
    </div>

    <div *ngIf="selectedTabButton.view === 'quizzes'" class="exams-content">
      <app-add-item-widget *ngIf="exams.length === 0" [message]="'Hier sieht es noch leer aus. Erstelle eine KI-Probeklausur und stelle dein Wissen auf die Prüfung.'" [buttonText]="'Probeklausur erstellen'" (buttonClicked)="createTest()"></app-add-item-widget>
      <app-button *ngIf="deviceSize === 'desktop' && exams.length > 0" [leftIcon]="'fas fa-plus'" [text]="'Neue Probeklausur'" [style]="'outlined'" [size]="'small'" (clickEvent)="createTest()"></app-button>
      <app-exam-list *ngIf="exams.length > 0" [exams]="exams" (examClicked)="handleExamClick($event)"></app-exam-list>
    </div>

    <app-add-button *ngIf="selectedTabButton.view === 'learnsets'" [text]="'Neues Lernset'" (clickEvent)="addLearnset()"></app-add-button>
    <app-add-button *ngIf="selectedTabButton.view === 'quizzes'" [text]="'Neue Probeklausur'" (clickEvent)="createTest()"></app-add-button>
  </ng-container>

  <!-- Create Learnset -->
  <app-bottom-dialog [isVisible]="createLearnset" [title]="'Lernset erstellen'" (actionCancelled)="createLearnset = false">
    <app-create-learnset *ngIf="createLearnset" [courseId]="course?.id!" (learnsetCreationFinished)="learnsetCreated()"></app-create-learnset>
  </app-bottom-dialog>

  <!-- Course Actions -->
  <app-bottom-dialog [isVisible]="showActions" [title]="'Aktionen'" (actionCancelled)="showActions = false">
    <app-action-buttons [buttonsList]="actionsList" (actionClicked)="handleAction($event)"></app-action-buttons>
  </app-bottom-dialog>

  <!-- Edit Course -->
  <app-bottom-dialog [isVisible]="showEditCourse" [title]="'Kurs bearbeiten'" (actionCancelled)="showEditCourse = false">
    <app-edit-course [course]="course" (finished)="showEditCourse = false"></app-edit-course>
  </app-bottom-dialog>

  <!-- Create Exam -->
  <app-bottom-dialog [isVisible]="showCreateExam" [iconName]="'file-ai'" [title]="'Probeklausur erstellen'" [closeOnOutsideClick]="false" (actionCancelled)="showCreateExam = false">
    <app-create-exam [course]="course"></app-create-exam>
  </app-bottom-dialog>
</div>